// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyCreateV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyCreateResponseV2WebDto, UserPropertyCreateV2RequestDto } from '../..';

export const RentalManagerUserPropertyCreateV2WebApiHandler_create_Path = '/api/web/v2/users/properties/create';

/**
 * Create a property for the user
 */
export const RentalManagerUserPropertyCreateV2WebApiHandler_create = (
  postData: UserPropertyCreateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyCreateV2RequestDto, UserPropertyCreateResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyCreateV2WebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
